import { computed, inject, Injectable, signal, Signal } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuDialogService } from '@app/core/services/au-dialog.service';
import { LocationsListComponent } from '../ui-components/locations-list/locations-list.component';
import { filteredBuildings } from '@app/states/locations/locations.selectors';
import { Store } from '@ngrx/store';
import { setLocationSearchText } from '@app/states/locations/locations.actions';
import { LocationNodeTypes } from '@app/domain/types';
import { IBuilding } from '../interfaces/building.interfaces';
import { ComponentOverlayDialogComponent } from '@app/core/dialogs/component-overlay-dialog/component-overlay-dialog.component';
import { getFollowedBuildings } from '@app/auth/state/auth.selectors';

@Injectable({
	providedIn: 'root',
})
export class LocationSelectorService {
	private readonly store$ = inject(Store);
	private readonly dialogService = inject(AuDialogService);

	myBuildingIds: Signal<Set<string>> = computed(() => {
		const buildings = this.store$.selectSignal(getFollowedBuildings);
		return new Set(buildings().map(building => building.id));
	});
	allLocations: Signal<IBuilding[]> = this.store$.selectSignal(filteredBuildings);

	filteredMyBuildings = computed(() => {
		return (
			this.allLocations()?.filter(building => this.myBuildingIds().has(building.id)) ||
			null
		);
	});

	filteredLocations = computed(() => {
		return (
			this.allLocations()?.filter(building => !this.myBuildingIds().has(building.id)) ||
			null
		);
	});

	selectedLocations = signal<LocationNodeTypes[]>([]);

	openLocationDialog() {
		const dialog: MatDialogRef<ComponentOverlayDialogComponent> =
			this.dialogService.openComponentOverlayDialog(
				LocationsListComponent,
				'choose_location',
				'locationsChanged'
			);

		dialog.afterClosed().subscribe((locations: LocationNodeTypes[]) => {
			if (!locations) {
				return;
			}
			this.selectedLocations.set(locations);
		});
	}

	setSearchText(searchText: string) {
		this.store$.dispatch(setLocationSearchText({ searchText }));
	}

	resetSearchText() {
		this.store$.dispatch(setLocationSearchText({ searchText: '' }));
	}
}
